import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight, faCaretDown } from "@fortawesome/free-solid-svg-icons";

const ExpandableFilters = ({ startCollapsed, children }) => {
  const [expanded, setExpanded] = useState(!startCollapsed);

  return (
    <>
      <h5
        role="button"
        aria-expanded={expanded}
        onClick={() => setExpanded(prevState => !prevState)}
        style={{ cursor: "pointer" }}
      >
        Rajaukset{" "}
        {expanded ? (
          <FontAwesomeIcon icon={faCaretDown} fixedWidth />
        ) : (
          <FontAwesomeIcon icon={faCaretRight} fixedWidth />
        )}
      </h5>
      {expanded ? children : null}
      <hr className="my-4" />
    </>
  );
};

export default ExpandableFilters;
